<template>
    <div class="d-block flex-row">
        <input type="password" class="custom-input input-underline w-100 text-center font-lg mx-1" maxlength="1" @keypress="inputCheck" @keyup="saveInput" v-for="index in parseInt(length)" :key="index" :step="index" required>
        <input type="hidden" :name="name" :value="value">
    </div>
</template>
<script>
export default {
    props:{
        length:{
            type:[Number, String],
            default:4
        },
        name:{
            type: String,
            default: null
        }
    },
    data:function(){
        return {
            value:null
        }
    },
    methods:{
        inputCheck(event){
            if(isNaN(event.key)){
                event.preventDefault();
                return;
            };
            if(event.target.step != this.$el.children.length) this.$el.children[event.target.step].focus();
            
        },
        saveInput(){
            this.value = [...this.$el.children].filter(el=>el.type!="hidden").reduce((val,el)=>{
                return val.concat(el.value);
            },"");
        }
    }
}
</script>